import api from '../api';
const today = new Date();
const oneMonthBefore = new Date(today);
oneMonthBefore.setMonth(oneMonthBefore.getMonth() - 1);

const state = {
    loading: true,
    activeCards: [
        {
            title: 'Active Users',
            classes: ['active'],
            valueKey: 'users'
        },
        {
            title: 'Number of Workouts',
            sub: 'Average per active user',
            valueKey: 'numberWorkout'
        },
        {
            title: 'Workout Duration',
            valueSuffix: ' Mins',
            sub: 'Average per active user',
            valueKey: 'workoutDuration'
        },
        {
            title: 'Workouts Completed',
            sub: 'Average per active user',
            valueKey: 'workoutsCompleted'
        },
    ],
    totalCards: [
        {
            title: 'Total Users',
            classes: ['total'],
            valueKey: 'users'
        },
        {
            title: 'Number of Workouts',
            sub: 'Total',
            valueKey: 'numberWorkout'
        },
        {
            title: 'Workout Duration',
            valueSuffix: ' Mins',
            sub: 'Total',
            valueKey: 'workoutDuration'
        },
        {
            title: 'Workouts Completed',
            sub: 'Total',
            valueKey: 'workoutsCompleted'
        },
    ],
    active: {
        users: null,
        workoutDuration: null,
        workoutDuration: null,
        workoutsCompleted: null
    },
    total: {
        users: null,
        workoutDuration: null,
        workoutDuration: null,
        workoutsCompleted: null
    },
    endDate: today,
    startDate: oneMonthBefore
};

const mutations = {
    setDashboardData(state, data) {
        state.total = data[0];
        state.active = data[1];
    },
    setLoading(state, loading) {
        state.loading = loading;
    },
    setStartDate(state, date) {
        state.startDate = date;
    },
    setEndDate(state, date) {
        state.endDate = date;
    }
};

const getters = {
    getActiveValue: (state) => (key) => {
        return state.active[key]
    },
    getTotalValue: (state) => (key) => {
        return state.total[key]
    }
};

const actions = {

    async loadDashboardData({ commit, state, rootGetters }) {

        commit("setLoading", true);

        let data = await api.getDashboardData(state.startDate, state.endDate);

        commit("setDashboardData", data);
        commit("setLoading", false);
    },
    async setStartDate({ commit, dispatch }, startDate) {
        commit("setStartDate", new Date(startDate))
        await dispatch('loadDashboardData');
    },
    async setEndDate({ commit, dispatch }, endDate) {
        commit("setEndDate", new Date(endDate));
        await dispatch('loadDashboardData');
    }


};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
